export const colors = {
  brand: {
    500: '#EA385D',
  },
};
